import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import SectionLabel from "./SectionLabel";

const ACCENTS = ["#00FF88", "#FFB800", "#00FF88"];

export default function Testimonials() {
  const { t } = useI18n();
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-20 md:py-32 border-t border-line">
      <div className="container-px mx-auto max-w-7xl">
        <SectionLabel>{t.testimonials.label}</SectionLabel>
        <h2 className="mt-6 font-display font-bold text-ink text-balance leading-[1.05]
                       text-3xl sm:text-5xl lg:text-6xl max-w-2xl">
          {t.testimonials.title}
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {t.testimonials.items.map((it, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className="card-tactical p-6 md:p-7 flex flex-col"
              data-testid={`testimonial-${i}`}
            >
              <Quote size={18} color={ACCENTS[i] || "#00FF88"} className="opacity-70" />
              <blockquote className="text-ink text-[15px] leading-relaxed mt-4 font-medium">
                "{it.q}"
              </blockquote>
              <figcaption className="mt-6 pt-6 border-t flex items-center gap-3" style={{ borderColor: "rgba(245,247,250,0.06)" }}>
                <div className="h-9 w-9 rounded-full hairline grid place-items-center mono-num text-[11px] text-ink"
                     style={{ background: "#262A33" }}>
                  {it.name.split(" ").map((p) => p[0]).join("")}
                </div>
                <div>
                  <p className="text-ink text-sm font-semibold">{it.name}</p>
                  <p className="label-tag text-[10px]">{it.role}</p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
